import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { Table } from 'primeng/table';
import { ActivatedRoute, Router } from "@angular/router";
import { ConfirmationService, MessageService } from 'primeng/api';
import { TitleCasePipe } from '@angular/common';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { LazyLoadEvent } from 'primeng/api';
import { Dropdown } from "primeng/dropdown";
import { environment } from 'src/environments/environment';
import { saveAs } from 'file-saver/src/FileSaver';
import * as moment from "moment";
import { AcademypaymentService } from 'src/app/services/academyPayment';
import { DateValidator } from 'src/app/_helpers/must-match.validator';
import { UserService } from 'src/app/services/user.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-user-subscription',
  templateUrl: './user-subscription.component.html',
  styleUrls: ['./user-subscription.component.scss'],
  styles: [`
        :host ::ng-deep .p-datatable-gridlines p-progressBar {
            width: 100%;
        }

        @media screen and (max-width: 960px) {
            :host ::ng-deep .p-datatable.p-datatable-customers.rowexpand-table .p-datatable-tbody > tr > td:nth-child(6) {
                display: flex;
            }
        }

    `],
  providers: [MessageService, ConfirmationService, TitleCasePipe]
})

export class UserSubscriptionHistoryComponent implements OnInit, OnDestroy {

    private destroy$ = new Subject<void>();
    errorMessage = '';
    statuses: any[];
    searchBy: any[];
    rowGroupMetadata: any;
    totalRecords: 0;
    virtualDatabase: any;
    userSubscriptionsList: any;
    userRoleId;
    userdetail: any;
    public item: any[] = [];
    public academyName;
    loading: boolean;
    paginationOption;
    private lastTableLazyLoadEvent: LazyLoadEvent;
    calvalue: Date;
    ucalvalue: Date;
    dcalvalue: Date;
    yearRange;
    minYear = environment.minYear;
    stDate: Date = new Date();
    startDate: Date;
    endDate: Date;
    downloadFlg: boolean;
    downloadUserPaymentsList: any;
    searchby;
    wdcalvalue;
    public hide: boolean = true;
    public catList: any[] = [];
    public brandList: any[] = [];
    public showFileUploadModal: boolean = false;
    public academyCsvFile;
    public uploadCsvFile: any[] = [];
    public academyImages: any[] = [];
    public uploadImageFiles: any[] = [];
    public showFileErrors: boolean = false;
    public showImageFileUploadModal: boolean = false;
    public showImageFileErrors: boolean = false;
    public editTransaction: boolean = false;
    public transvalue;
    public expiryvalue;
    public academyDetails;
    public editPaymentForm: FormGroup;
    public transactionSubmitted: boolean = false;
    public minimumDate = new Date();
    @ViewChild("dt", { static: false }) public dt: Table;
    @ViewChild("pDropDownId", { static: false }) pDropDownId: Dropdown;
    profileDetails: any;
    userName: any;
    id:string;
    constructor( private academyPaymentService: AcademypaymentService, private router: Router, private route: ActivatedRoute, private messageService: MessageService, private confirmationService: ConfirmationService,        
        private formBuilder: FormBuilder,
        private activeroute: ActivatedRoute,
        private userService: UserService,
    ) { }

    ngOnInit() {
        this.paginationOption = environment.pagination;
        this.id = this.activeroute.snapshot.params.id;
        this.yearRange = environment.yearRange;
        this.statuses = [
            { label: 'Pending', value: "pending" },
            { label: 'Completed', value: "completed" },
            { label: 'Failed', value: "failed" },
            { label: 'Refunded', value: "refunded" }
        ];
        this.searchBy = [
            { label: 'Created On', value: "created_at" },
            { label: 'Last Modified On', value: "updated_at" }
        ];
        this.downloadFlg = false;
        this.editPaymentForm = this.formBuilder.group({
            academyId:[],
            paymentId:[],
            transactionDate: ['', [Validators.required]],
            expiryDate: ['', [Validators.required]]
        }, {
            validator: DateValidator('transactionDate', 'expiryDate')
        });
        this.getUserDetails(this.id);
    }

    getUserDetails(userId) {
      this.userService.getUserDetails(userId).pipe(takeUntil(this.destroy$)).subscribe(
        data => {
          this.item = data;
          if (this.item) {
            this.profileDetails = this.item;
            this.userName = this.profileDetails?.fullName;
            // this.mobileNumber = 

          }

        }, err => {
  
        });
  
    }

    get f() {
        return this.editPaymentForm.controls;
    }
    clear() {
        this.startDate = null;
        this.endDate = null;
        this.searchby = '';
        this.dt.filter('', 'amount', 'contains');
        this.dt.filter('', 'orderId', 'contains');
        this.dt.filter('', 'receiptId', 'contains');
        this.dt.filter('', 'paymentId', 'contains');
        this.dt.filter('', 'transactionDate', 'contains');
        this.dt.filter('', 'invoiceId', 'contains');
        this.dt.filter('', 'expiryDate', 'contains');
        this.dt.filter('', 'status', 'contains');
        this.dt.filter('', 'created_at', 'dateIs');
        this.dt.filter('', 'createdby', 'contains');
        this.dt.filter('', 'updated_at', 'dateIs');
        this.dt.filter('', 'updatedby', 'contains');
        this.dt.filter('', 'preferredwaytocontact', 'contains');
        this.dt.filter('', 'mobileNumber', 'contains');
        this.calvalue = null;
        this.transvalue = null;
        this.expiryvalue = null;
        this.ucalvalue = null;
        this.dcalvalue = null;
        this.wdcalvalue = null;
        this.pDropDownId.clear(null);
        if (this.pDropDownId) {
            this.pDropDownId.value = null;
        }
    }

    loadUserSubscriptions(event: LazyLoadEvent) {
        this.lastTableLazyLoadEvent = event;
        let query = "filterByUserId=" + this.id;
        let pagenumber = 1;
        let params = "";
        let rows;
        if (event.first != undefined && event.first == 0) {
            pagenumber = event.first + 1;
        } else if (event.first != undefined && event.first > 0) {
            pagenumber = (event.first / event.rows) + 1;
        } else {
            pagenumber = 1;
        }
        if (event.rows != undefined) {
            rows = event.rows;
        } else {
            rows = 10;
        }

        if (this.searchby != undefined && this.startDate != undefined && this.endDate != undefined) {
            params += "&filterByDate=" + this.searchby.value;
            params += "&filterByStartDate=" + moment(this.startDate).format("YYYY-MM-DD");
            params += "&filterByEndDate=" + moment(this.endDate).format("YYYY-MM-DD");
        }
        if (event.filters != undefined && event.filters["amount"] != undefined) {
            params += "&filterByAmount=" + event.filters["amount"].value;
        }
        if (event.filters != undefined && event.filters["paymentStatus"] != undefined) {
            params += "&filterByPaymentStatus=" + event.filters["paymentStatus"].value;
        }
        if (event.filters != undefined && event.filters["id"] != undefined) {
            params += "&filterById=" + event.filters["id"].value;
        }
        if (event.filters != undefined && event.filters["orderId"] != undefined) {
            params += "&filterByOrderId=" + event.filters["orderId"].value;
        }
        if (event.filters != undefined && event.filters["receiptId"] != undefined) {
            params += "&filterByReceiptId=" + event.filters["receiptId"].value;
        }
        if (event.filters != undefined && event.filters["invoiceId"] != undefined) {
            params += "&filterByInvoiceId=" + event.filters["invoiceId"].value;
        }
        if (event.filters != undefined && event.filters["paymentId"] != undefined) {
            params += "&filterByPaymentId=" + event.filters["paymentId"].value;
        }

        if (event.filters != undefined && event.filters["transactionDate"] != undefined) {
            const transactionDate = moment(event.filters["transactionDate"].value).format("YYYY-MM-DD");
            params += "&filterByTransactionDate=" + transactionDate;
        }
        if (event.filters != undefined && event.filters["expiryDate"] != undefined) {
            const expiryDate = moment(event.filters["expiryDate"].value).format("YYYY-MM-DD");
            params += "&filterByExpiryDate=" + expiryDate;
        }
        if (event.filters != undefined && event.filters["created_at"] != undefined) {
            const createdAt = moment(event.filters["created_at"].value).format("YYYY-MM-DD");
            params += "&filterByCreatedAt=" + createdAt;
        }
        if (event.filters != undefined && event.filters["createdby"] != undefined) {
            params += "&filterByCreatedby=" + event.filters["createdby"].value;
        }
        if (event.filters != undefined && event.filters["updated_at"] != undefined) {
            const createdAt = moment(event.filters["updated_at"].value).format("YYYY-MM-DD");
            params += "&filterByUpdatedAt=" + createdAt;
        }
        if (event.filters != undefined && event.filters["updatedby"] != undefined) {
            params += "&filterByUpdatedby=" + event.filters["updatedby"].value;
        }
        // at the time of download hide pagination option
        if (this.downloadFlg == false) {
            if (params != undefined && params != "") {
                query += "&pageSize=" + rows + "&pageNumber=" + pagenumber + params;
            } else {
                query += "&pageSize=" + rows + "&pageNumber=" + pagenumber;
            }
        } else {
            if (params != undefined && params != "") {
                query += params;
            }
        }

        if (event.sortField != undefined && event.sortOrder != undefined) {
            let orderBy = "";
            if (event.sortOrder == 1) {
                orderBy = "DESC";
            } else {
                orderBy = "ASC";
            }
            query += "&sortBy=" + event.sortField + "&orderBy=" + orderBy;
        }
        /**
        * Sequence wise sort.
        **/
        // else {
        //     query += "&sortBy=getSequencewise" + "&orderBy=desc";
        // }
        this.userService.getUserSubscriptions(query).pipe(takeUntil(this.destroy$)).subscribe(
            (data:any) => {
                if (this.downloadFlg === false) {
                    this.loading = false;
                    this.userSubscriptionsList = data.items;
                    this.userSubscriptionsList.forEach((element, index) => {
                        if(element.status == "free") {
                            element.showFree = true;
                        } else {
                            element.showFree = false;
                        }
                    })
                    this.totalRecords = data.totalCount;
                } else {
                    this.exportExcelData(data.items);
                    this.downloadFlg = false;
                }
            },
            err => {
                this.errorMessage = err.error.message;
            });
    }

    func(prop, val) {
        let jsonStr = '{"' + prop + '":"' + val + '"}';
        return JSON.parse(jsonStr);
    }

    editTrasaction(academy) {
        this.editTransaction = true;        
        this.editPaymentForm.get('academyId').setValue(academy['academyId']);
        this.editPaymentForm.get('paymentId').setValue(academy['id']);
        if (academy['transactionDate']) {
            this.editPaymentForm.get('transactionDate').setValue(moment(academy['transactionDate']).format('DD-MM-YYYY'));
        }
        if (academy['expiryDate']) {
            this.editPaymentForm.get('expiryDate').setValue(moment(academy['expiryDate']).format('DD-MM-YYYY'));
        }
    }  
    stdt: Date;
    eddt: Date;
    setStartDate($event) {
        this.stdt = $event; //moment($event).format("MM/DD/YYYY");
    }
    setEndDate($event) {
        this.eddt = $event; //moment($event).format("MM/DD/YYYY");
    }  
    onSubmit() {
        this.transactionSubmitted = true;
        if (this.editPaymentForm.invalid) {
            return;
        }
        let paymentData = this.editPaymentForm.value;           
        let paymentId = paymentData['paymentId'];
        // if (this.stdt != undefined) {
        //     paymentData['transactionDate'] = moment(this.stdt).toDate();
        // }
        // if (this.eddt != undefined) {
        //     paymentData['expiryDate'] = moment(this.eddt).toDate();
        // }

        if (this.editPaymentForm.value.transactionDate instanceof Date) {
            paymentData['transactionDate'] = moment(this.editPaymentForm.value.transactionDate, "DD-MM-YYYY").format("YYYY-MM-DD");
        } else {
            var dt = moment(this.editPaymentForm.value.transactionDate, "DD-MM-YYYY").format("YYYY-MM-DD");
            paymentData['transactionDate'] = dt;
        }

        if (this.editPaymentForm.value.expiryDate instanceof Date) {
            paymentData['expiryDate'] = moment(this.editPaymentForm.value.expiryDate, "DD-MM-YYYY").format("YYYY-MM-DD");
        } else {
            var dt = moment(this.editPaymentForm.value.expiryDate, "DD-MM-YYYY").format("YYYY-MM-DD");
            paymentData['expiryDate'] = dt;
        }


        delete paymentData['academyId'];
        let updateData = JSON.stringify(paymentData, null, 4);                
        this.academyPaymentService.updateAcademyPayment(paymentId, updateData).pipe(takeUntil(this.destroy$)).subscribe(
            data => {
                this.messageService.add({ key: 'toastmsg', severity: 'success', summary: 'Successful', detail: 'Subscription Dates updated', life: 3000 });
                this.editTransaction = false;      
                this.loadUserSubscriptions(this.lastTableLazyLoadEvent);
            },
            err => {
                this.errorMessage = err.error.message;
            }
        );
    }
    editTransactionClose() {
        this.editTransaction = false;
    }

    addNewAcademyPayment() {
        this.router.navigate(['/manage/academies/add']);
    }

    viewAcademyPayment(id) {
        this.router.navigate(['/manage/academies/view/' + id]);
    }

    editAcademyPayment(id) {
        this.router.navigate(['/manage/academies/edit/' + id]);
    }

    findIndexById(id: string): number {
        let index = -1;
        for (let i = 0; i < this.userSubscriptionsList.length; i++) {
            if (this.userSubscriptionsList[i].id === id) {
                index = i;
                break;
            }
        }
        return index;
    }

    editmedia(id) {
        this.router.navigate(['manage/academies/media/' + id]);
    }

    showUploadModal() {
        this.showFileUploadModal = true;
    }
    showImageUploadModal() {
        this.showImageFileUploadModal = true;
    }

    setDownloadFlag() {
        this.downloadFlg = false;
    }

    exportExcel() {
        this.downloadFlg = true;
        this.loadUserSubscriptions(this.lastTableLazyLoadEvent);
    }
    
    exportExcelData(userSubscriptionsList) {
        let propertiesRemove = ['userId','academiesdata', 'membershipId', 'walletPaymentId','userWalletId', 'membershipBenefits', 'academyId', 'userdetails', 'id', 'created_at', 'createdby', 'updatedby', 'disable', 'updated_at', 'categoryId', 'status', 'created_by', 'Modification_Date', 'invoiceFile'];
        this.downloadUserPaymentsList = userSubscriptionsList;
        this.downloadUserPaymentsList.forEach(function (item) {
            propertiesRemove.forEach(function (prop) {
                delete item[prop];
            });
        });
        import("xlsx").then(xlsx => {
            const worksheet = xlsx.utils.json_to_sheet(this.downloadUserPaymentsList);
            const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
            const excelBuffer: any = xlsx.write(workbook, {
                bookType: "xlsx",
                type: "array"
            });
            this.saveAsExcelFile(excelBuffer, "User Payment Details");
        });
    }


    saveAsExcelFile(buffer: any, fileName: string): void {
        import("file-saver").then(FileSaver => {
            let EXCEL_TYPE =
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
            let EXCEL_EXTENSION = ".xlsx";
            const data: Blob = new Blob([buffer], {
                type: EXCEL_TYPE
            });
            let filename;
            filename = fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION;
            saveAs(data, filename);
        });
    }

    /**
     * Use to add more columns in the table.
    */
    addColumns() {
        this.hide = false;
    }

    /**
    * Use to remove more columns in the table.
    */
    removeColumns() {
        this.hide = true;
    }

    academyPayment(id) {
        this.router.navigate(['/payments' + id]);
    }

    downloadPdf(invoiceFile) {
        window.open(invoiceFile);
    }

    markFree(id, status) {
  let markedStr: string;
  let paymentStatus: string;
  let successMsg: string;

  if (status === 'created') {
    markedStr = 'Do you want to assign Free membership?';
    paymentStatus = 'free';
    successMsg = 'Marked as Free Successfully';
  } else {
    markedStr = 'Do you want to cancel Free membership?';
    paymentStatus = 'created';
    successMsg = 'Free Membership Cancelled Successfully';
  }

  this.confirmationService.confirm({
    message: `
      <h4 style="margin:0;">Are you sure?</h4>
      <p style="margin-top:10px;">
        ${markedStr}
      </p>
    `,
    header: 'Confirm',
    icon: 'pi pi-exclamation-triangle',
    accept: () => {
      const updateData = JSON.stringify({ status: paymentStatus });

      this.academyPaymentService
        .updateAcademyPayment(id, updateData).pipe(takeUntil(this.destroy$))
        .subscribe(
          () => {
            this.messageService.add({
              key: 'toastmsg',
              severity: 'success',
              summary: 'Successful',
              detail: successMsg,
              life: 3000
            });

            this.loadUserSubscriptions(this.lastTableLazyLoadEvent);
          },
          err => {
            this.errorMessage = err.error.message;
          }
        );
    },
    reject: () => {
      this.loadUserSubscriptions(this.lastTableLazyLoadEvent);
    }
  });
}

    sendInvoice(subscriptionId:string) {        
        let markedStr="Do you want to regenerate invoice ?"
        this.confirmationService.confirm({
             message: `
      <h4 style="margin:0;">Are you sure?</h4>
      <p style="margin-top:10px;">
        ${markedStr}
      </p>
    `,

            // message: markedStr,
            header: 'Confirm',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                this.userService.generateUserSubscriptionInvoice(subscriptionId).pipe(takeUntil(this.destroy$)).subscribe(
                    (data:Blob) => {
                        this.messageService.add({ key: 'toastmsg', severity: 'success', summary: 'Successful', detail: 'invoice regenerated', life: 3000 });
                        setTimeout(() => {
                            this.loadUserSubscriptions(this.lastTableLazyLoadEvent);
                        },2000);
                    },
                    err => {
                        this.errorMessage = err.error.message;
                    }
                );
            },
            reject: () => {
                this.loadUserSubscriptions(this.lastTableLazyLoadEvent);
            }
        });
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
